import { mitoPalettes, type MitoThemeName } from "./tokens";

const THEME_CLASSES = Object.values(mitoPalettes).map((p) => p.className);

export function applyMitoThemeClass(name: MitoThemeName | null) {
  if (typeof document === "undefined") {
    return;
  }
  const root = document.documentElement;
  THEME_CLASSES.forEach((cls) => root.classList.remove(cls));
  if (name) {
    root.classList.add(mitoPalettes[name].className);
    root.classList.toggle("mito-brand", name === "orange");
  }
}

export function resolveMitoThemeName(useOrange: boolean): MitoThemeName | null {
  return useOrange ? "orange" : null;
}
